(function () {
  function initComparisonTabs(section) {
    if (!section || section.dataset.comparisonTabsInitialized === 'true') return;

    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

    if (!tabs.length || !panels.length) return;

    const activateTab = (tab) => {
      const targetId = tab.getAttribute('data-tab-target');
      const targetPanel = section.querySelector('#' + CSS.escape(targetId));

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel === targetPanel;
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (event) {
        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'Right':
            event.preventDefault();
            nextIndex = (index + 1) % tabs.length;
            break;

          case 'ArrowLeft':
          case 'Left':
            event.preventDefault();
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            break;

          case 'Home':
            event.preventDefault();
            nextIndex = 0;
            break;

          case 'End':
            event.preventDefault();
            nextIndex = tabs.length - 1;
            break;

          case 'Enter':
          case ' ':
            event.preventDefault();
            activateTab(tab);
            return;

          default:
            return;
        }

        const nextTab = tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
          activateTab(nextTab);
          nextTab.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });
    });

    section.dataset.comparisonTabsInitialized = 'true';
  }

  function initAllComparisonTabs() {
    const sections = document.querySelectorAll('.comparison-tabs-section');
    sections.forEach(initComparisonTabs);
  }

  document.addEventListener('DOMContentLoaded', initAllComparisonTabs);
  document.addEventListener('shopify:section:load', function (event) {
    initComparisonTabs(event.target);
  });
  document.addEventListener('shopify:section:reorder', initAllComparisonTabs);
})();